export default __webpack_public_path__ + "static/media/29.45d5ead3.jpeg";